import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCodeLarge: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCodeLarge"><Path d="M8.5 5.5L2 12L8.5 18.5" stroke="currentColor" strokeLinecap="square"/><Path d="M15.5 5.5L22 12L15.5 18.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCodeLarge;
